// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import { DEFAULT_CITY, DOWNLOAD_TASK_TYPE } from '../constants'

export const map = {
  state: {
    center: [DEFAULT_CITY.longitude, DEFAULT_CITY.latitude],
    boundingBox: [],
    zoom: [10],
    isShowCameras: true,
    isShowRoads: false,
    fitBounds: null,
    fitBoundsOptions: null
  },
  reducers: {
    setCenter: (state, center) => ({ ...state, center }),
    setCamerasShow: (state, isShowCameras) => ({ ...state, isShowCameras }),
    setViewport: (state, viewport) => ({ ...state, ...viewport }),
    setFitBounds: (state, payload) => ({
      ...state,
      fitBounds: payload.fitBounds,
      fitBoundsOptions: payload.fitBoundsOptions
    }),
    clear () {
      return {
        center: [DEFAULT_CITY.longitude, DEFAULT_CITY.latitude],
        boundingBox: [],
        zoom: [10],
        isShowCameras: true,
        isShowRoads: false,
        fitBounds: null,
        fitBoundsOptions: null
      }
    }
  },
  effects: dispatch => ({
    setDefaultCenter: async (_, rootState) => {
      const city = rootState.city.current || rootState.city.cityList[0]
      if (city) {
        dispatch.map.setCenter([city.longitude, city.latitude])
      }
    },
    onViewportChange: async (viewport, rootState) => {
      dispatch.map.setViewport(viewport)
      const { editingPreTask, mode } = rootState.download
      if (editingPreTask.jobType === DOWNLOAD_TASK_TYPE.ROAD && mode === 'add') {
        await dispatch.road.fetchRoadData()
      }
    }
    // onView
  })
}
